<template>
  <div :class="modifiedClasses">
    <div v-if="navigation.className == 'Block'" :class="navigation.style">
      <InlineObject
        v-for="inlineObject in navigation.inlineObjects"
        :key="inlineObject.id"
        :navigation="inlineObject"
        :selectedObjectId="selectedObjectId"
        @triggerRefresh="triggerRefresh"
        @updateNavigation="updateNavigation($event)"
      />
    </div>
    <RenderItem
      styleClass="nostyle"
      :navigation="navigation"
      v-if="navigation.className == 'FreeText'"
      :selectedObjectId="selectedObjectId"
      @triggerRefresh="triggerRefresh"
      @updateNavigation="updateNavigation($event)"
    >
      <span class="navigation.style">{FreeText}</span>
    </RenderItem>
    <RenderItem
      styleClass="nostyle"
      :navigation="navigation"
      v-if="navigation.className == 'Hr'"
      :selectedObjectId="selectedObjectId"
      @triggerRefresh="triggerRefresh"
      @updateNavigation="updateNavigation($event)"
    >
      <hr />
    </RenderItem>
    <ol
      v-if="
        navigation.className == 'ListElement' && navigation.type == 'ordered'
      "
      :class="navigation.style"
      :type="navigation.typeordered ? navigation.typeordered : '1'"
    >
      <block-object-render
        v-for="listItem in navigation.listItems"
        :key="listItem.id"
        :navigation="listItem"
        :selectedObjectId="selectedObjectId"
        @triggerRefresh="triggerRefresh"
        @updateNavigation="updateNavigation($event)"
      />
    </ol>
    <ul
      v-if="
        navigation.className == 'ListElement' && navigation.type != 'ordered'
      "
      :class="navigation.style"
      :id="`selectedMain${navigation.id}`"
    >
      <block-object-render
        v-for="listItem in navigation.listItems"
        :key="listItem.id"
        :navigation="listItem"
        :selectedObjectId="selectedObjectId"
        @triggerRefresh="triggerRefresh"
        @updateNavigation="updateNavigation($event)"
      />
    </ul>
    <li
      :id="`selectedMain${navigation.id}`"
      :class="navigation.style"
      v-if="navigation.className == 'ListItem'"
    >
      <block-object-render
        v-for="blockObject in navigation.blockObjects"
        :key="blockObject.id"
        :navigation="blockObject"
        :selectedObjectId="selectedObjectId"
        @triggerRefresh="triggerRefresh"
        @updateNavigation="updateNavigation($event)"
      />
    </li>
    <div style="clear: both" v-if="navigation.className == 'MultiEntry'">
      <block-object-render
        v-for="multiEntryOption in navigation.multiEntryOptions"
        :key="multiEntryOption.id"
        :navigation="multiEntryOption"
        :selectedObjectId="selectedObjectId"
        @triggerRefresh="triggerRefresh"
        @updateNavigation="updateNavigation($event)"
      />
    </div>
    <RenderItem
      styleClass="nostyle"
      :navigation="navigation"
      v-if="navigation.className == 'MultiEntryOption'"
      :selectedObjectId="selectedObjectId"
      @triggerRefresh="triggerRefresh"
      @updateNavigation="updateNavigation($event)"
    >
      <span style="font-family: ZapfDingbats">&#x274F;</span>&#160;
      <span :contenteditable="true" @input="onInput" @keydown.enter.prevent>{{
        navigation.value
      }}</span>
    </RenderItem>
    <div
      style="clear: both"
      v-if="navigation.className == 'Qa' && navigation.question"
    >
      <div style="float: left">Q.</div>
      <div style="margin-left: 40px">
        <block-object-render
          v-for="blockObject in navigation.question.blockObjects"
          :key="blockObject.id"
          :navigation="blockObject"
          :selectedObjectId="selectedObjectId"
          @triggerRefresh="triggerRefresh"
          @updateNavigation="updateNavigation($event)"
        />
      </div>
    </div>
    <div
      style="clear: both"
      v-if="navigation.className == 'Qa' && navigation.answer"
    >
      <div style="float: left">A.</div>
      <div style="margin-left: 40px">
        <block-object-render
          v-for="blockObject in navigation.answer.blockObjects"
          :key="blockObject.id"
          :navigation="blockObject"
          :selectedObjectId="selectedObjectId"
          @triggerRefresh="triggerRefresh"
          @updateNavigation="updateNavigation($event)"
        />
      </div>
    </div>
    <div
      v-if="navigation.className == 'SectionElement'"
      :id="`selectedMain${navigation.id}`"
    >
      <block-object-render
        v-for="blockObject in navigation.blockObjects"
        :key="blockObject.id"
        :navigation="blockObject"
        :selectedObjectId="selectedObjectId"
        @triggerRefresh="triggerRefresh"
        @updateNavigation="updateNavigation($event)"
      />
    </div>
    <RenderItem
      styleClass="nostyle"
      :navigation="navigation"
      v-if="navigation.className == 'SnippetInsert'"
      :selectedObjectId="selectedObjectId"
      @triggerRefresh="triggerRefresh"
      @updateNavigation="updateNavigation($event)"
    >
      <span :class="navigation.style">
        <span v-if="navigation.snippetid"
          >{Snippet {{ navigation.snippetid }} |
          {{ navigation.snippet.name }} }</span
        >
      </span>
    </RenderItem>
    <RenderItem
      styleClass="nostyle"
      :navigation="navigation"
      v-if="navigation.className == 'Spacer'"
      :selectedObjectId="selectedObjectId"
      @triggerRefresh="triggerRefresh"
      @updateNavigation="updateNavigation($event)"
    >
      <span class="navigation.style">
        <div v-for="n in navigation.size" :key="n">.</div>
      </span>
    </RenderItem>
    <table
      :class="navigation.style"
      v-if="navigation.className == 'Table'"
      :id="`selectedMain${navigation.id}`"
    >
      <tr
        :class="row.style"
        v-for="row in navigation.rows"
        :key="row.id"
        :id="`selectedMain${row.id}`"
      >
        <td
          :class="cell.style"
          v-for="cell in row.cells"
          :key="cell.id"
          :id="`selectedMain${cell.id}`"
        >
          <block-object-render
            v-for="blockObject in cell.blockObjects"
            :key="blockObject.id"
            :navigation="blockObject"
            :selectedObjectId="selectedObjectId"
            @triggerRefresh="triggerRefresh"
            @updateNavigation="updateNavigation($event)"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import InlineObject from "@/components/document/revision/render/InlineObject";
import RenderItem from "@/components/document/revision/render/RenderItem";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "BlockObject",
  props: ["navigation", "selectedObjectId"],
  components: { InlineObject, RenderItem },
  computed: {
    selected() {
      if (
        this.navigation &&
        this.selectedObjectId &&
        this.navigation.id == this.selectedObjectId
      ) {
        return true;
      }
      return false;
    },
    modifiedClasses() {
      if (this.navigation == undefined) {
        return undefined;
      }
      let value = "";
      if (this.selected) {
        value += " templateSelected";
      }
      if (this.navigation.className == "Block") {
        if (this.navigation.omit) {
          value += this.navigation.omitDefault
            ? " templateOmitDefault"
            : " templateOmit";
        }
        if (this.navigation.space) {
          value += " templateSpace";
        }
        if (this.navigation.align == 1) {
          value += " templateCentre";
        } else if (this.navigation.align == 2) {
          value += " templateRight";
        }
        if (
          this.navigation.omitValue &&
          this.navigation.omitValue.value != undefined &&
          this.navigation.omitValue.value
        ) {
          value += " omitHidden";
        }
      }
      if (this.navigation.className == "Cell") {
        if (this.navigation.border) {
          value += " templateBorder";
        }
        if (this.navigation.pad) {
          value += " templatePad";
        }
        if (this.navigation.shade) {
          value += " templateShade";
        }
      }
      //     if (this.navigation.className == 'Hr') {
      // }
      if (this.navigation.className == "ListElement") {
        if (this.navigation.omit) {
          value += this.navigation.omitDefault
            ? " templateOmitDefault"
            : " templateOmit";
        }
        if (this.navigation.space) {
          value += " templateListSpace";
        }
        if (
          this.navigation.omitValue &&
          this.navigation.omitValue.value != undefined &&
          this.navigation.omitValue.value
        ) {
          value += " omitHidden";
        }
      }
      if (this.navigation.className == "ListItem") {
        if (this.navigation.omit) {
          value += this.navigation.omitDefault
            ? " templateOmitDefault"
            : " templateOmit";
        }
        if (
          this.navigation.omitValue &&
          this.navigation.omitValue.value != undefined &&
          this.navigation.omitValue.value
        ) {
          value += " omitHidden";
        }
      }
      //     if (this.navigation.className == 'Qa') {
      // }
      if (this.navigation.className == "Row") {
        if (this.navigation.omit) {
          value += this.navigation.omitDefault
            ? " templateOmitDefault"
            : " templateOmit";
        }
      }
      if (this.navigation.className == "SectionElement") {
        if (this.navigation.omit) {
          value += this.navigation.omitDefault
            ? " templateOmitDefault"
            : " templateOmit";
        }
      }
      if (
        this.navigation.className == "FreeText" ||
        this.navigation.className == "SnippetInsert"
      ) {
        value += " templatePlaceholder";
      }
      //    if (this.navigation.className == 'Spacer') {
      // }
      if (this.navigation.className == "Table") {
        if (this.navigation.collapse) {
          value += " templateCollapse";
        }
        if (this.navigation.space) {
          value += " templateSpace";
        }
      }
      // console.log(this.navigation.className + " " + value);
      return value;
    }
  },
  data() {
    return { timerId: null };
  },
  methods: {
    updateNavigation(navigation) {
      // console.log(navigation);
      this.$emit("updateNavigation", navigation);
    },
    triggerRefresh() {
      this.$emit("triggerRefresh");
    },
    onInput(e) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        const value = e.target.innerText;
        // console.log(value);
        this.updateSelected(value);
      }, 1750);
    },
    async updateSelected(value) {
      await nbmlaw.put(
        `/cors/admin/document/navigations/${this.navigation.id}/MultiEntryOption/value`,
        value
      );
      // console.log(response.data);
      this.$emit("triggerRefresh");
    }
  }
};
</script>
